import {
  faTemperatureEmpty,
  faTemperatureFull,
  faTemperatureHalf,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import DefaultText from "../../../components/Accessibility/DefaultText";
import DefaultTextBold from "../../../components/Accessibility/DefaultTextBold";
import WhiteContainer from "../../../components/Accessibility/WhiteContainer";
import { HistoricoItem } from "../../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/HistoricoItem";
import { TipoHistoricoEnum } from "../../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/TipoHistoricoEnum";

interface Props {
  dados: HistoricoItem[];
}

const AutoAvaliacaoHistorico: React.FC<Props> = ({ dados }) => {
  const navigate = useNavigate();

  const deParaStatus = (status: TipoHistoricoEnum) => {
    switch (status) {
      case TipoHistoricoEnum.Baixo:
        return { icon: faTemperatureEmpty, color: "#156D44" };
      case TipoHistoricoEnum.Moderado:
        return { icon: faTemperatureHalf, color: "#F47920" };
      case TipoHistoricoEnum.Elevado:
      default:
        return { icon: faTemperatureFull, color: "#D84141" };
    }
  };

  return (
    <ul className="historico-container">
      {dados.map((item) => {
        const status = deParaStatus(item.tipo);
        return (
          <button 
            key={`${item.data}-${item.hora}`} 
            className="historico-button"
            aria-label={`Ver avaliação de tipo ${item.tipo} em ${item.data} às ${item.hora}`}
          >
            <WhiteContainer
              aria-label={`Ver avaliação de tipo ${item.tipo} em ${item.data} às ${item.hora}`}
              tabIndex={0}
              className="historico-item-container"
              onClick={() =>
                navigate(
                  `/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes/${item.idRespQuestBenef}`
                )
              }
			        onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(
                  `/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes/${item.idRespQuestBenef}`
                  )
                }
			        }}
            >
              <FontAwesomeIcon
                className="temperature-icon"
                icon={status.icon}
                color={status.color}
              />
              <DefaultText fontWeight={700} text={item.data} />
              <DefaultText text={item.hora} />
            </WhiteContainer>
          </button>
        );
      })}
    </ul>
  );
};

export default AutoAvaliacaoHistorico;
